module.exports = __webpack_public_path__ + "img/book5.65571980.png";